// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-side-list,
ccm-side-list {
  max-width: initial;
}
.fi-side-list > .CcmSideList,
ccm-side-list > .CcmSideList {
  padding: 6px 0;
}
.fi-side-list > .CcmSideList > .CcmSideListItem,
ccm-side-list > .CcmSideList > .CcmSideListItem {
  padding-right: 35px;
}
.fi-side-list > .CcmSideList > .CcmSideListItem > .side-list-item-error,
ccm-side-list > .CcmSideList > .CcmSideListItem > .side-list-item-error {
  position: absolute;
  right: 0;
  display: inline-block;
  height: 16px;
  top: calc(50% - 8px);
}
.fi-side-list .language-version,
ccm-side-list .language-version {
  padding-left: 30px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./Source/app/utilities/side-list/side-list.component.scss"],"names":[],"mappings":"AAAA;;EAEI,kBAAA;AACJ;AACI;;EACI,cAAA;AAER;AAAQ;;EACI,mBAAA;AAGZ;AADY;;EACI,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,YAAA;EACA,oBAAA;AAIhB;AACI;;EACI,kBAAA;EACA,iBAAA;AAER","sourcesContent":[".fi-side-list,\r\nccm-side-list {\r\n    max-width: initial;\r\n\r\n    > .CcmSideList {\r\n        padding: 6px 0; // padding to add some space for error\r\n\r\n        > .CcmSideListItem {\r\n            padding-right: 35px; // padding to add space for error\r\n\r\n            > .side-list-item-error {\r\n                position: absolute;\r\n                right: 0;\r\n                display: inline-block;\r\n                height: 16px;\r\n                top: calc(50% - 8px);\r\n            }\r\n        }\r\n    }\r\n\r\n    .language-version {\r\n        padding-left: 30px;\r\n        font-weight: bold;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
